import axios from 'axios'
import apiUrl from '../_const'

export default {
  getComputes () {
    return axios.get(apiUrl.COMPUTE_URL, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  createCompute ({commit}, data) {
    return axios.post(apiUrl.COMPUTE_URL, {
      name: data.name,
      image: data.image,
      flavor: data.flavor,
      keypair: data.keypair,
      size: parseInt(data.size),
      type: data.type
    }, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  shutdownCompute ({ commit }, id) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + id + '/shutdown', null, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  deleteCompute ({ commit }, id) {
    return axios.delete(apiUrl.COMPUTE_URL + '/' + id, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  startCompute ({ commit }, id) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + id + '/start', null, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  getAttachedSecurityGroups ({ commit }, id) {
    return axios.get(apiUrl.COMPUTE_URL + '/' + id + '/security_groups', {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  setSecurityGroupsToCompute ({ commit }, id, form) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + id + '/security_groups', {
      form
    }, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  attachVolume ({ commit }, data) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + data.ComputeId + '/volume', data, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  detachVolume ({ commit }, data) {
    return axios.delete(apiUrl.COMPUTE_URL + '/' + data.ComputeId + '/volume/' + data.volume_id, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  resize ({ commit }, data) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + data.id + '/resize', data, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  confirmResize ({ commit }, data) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + data.id + '/confirmresize', data, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  },
  resetResize ({ commit }, data) {
    return axios.post(apiUrl.COMPUTE_URL + '/' + data.id + '/resetresize', data, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).catch((error) => {
      return new Error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/openstack/modules/computes.js